import { Calendar } from 'lucide-react'
import { Card } from '@/components/ui'

const FollowUpListPage = () => (
  <div className="p-4">
    <h1 className="text-xl font-bold mb-4">Follow-ups</h1>
    <Card>
      <div className="flex items-center gap-3">
        <Calendar size={24} className="text-blue-500" />
        <p>Follow-up list will appear here</p>
      </div>
    </Card>
  </div>
)
export default FollowUpListPage
